module.exports = __webpack_public_path__ + "static/media/metrocorp-logo.7032d930.svg";